export enum CommissionPayoutMethodEnum {
	Direct_Deposit = 1,
	Bank_Transfer = 2,
	PayPal = 3,
	Stripe = 4,
}

export enum CommissionBillingCycleEnum {
	Monthly = 1,
	Yearly = 2,
	Weekly = 3,
}

export enum CommissionCategoryTypeEnum {
	Local_Service = 1,
	Professional_Service = 2,
	International_Service = 3,
	Emergency_Service = 4,
}

export enum CommissionStatusEnum {
	Active = 1,
	Inactive = 2,
}

export enum CommissionTierNameEnum {
	Standard = 1,
	Silver = 2,
	Gold = 3,
	Platinum = 4,
}
